import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-bulk-move-to-application',
  imports: [SharedModule],
  templateUrl: './bulk-move-to-application.component.html',
  styleUrl: './bulk-move-to-application.component.scss'
})
export class BulkMoveToApplicationComponent {
  @Output() closeDialog = new EventEmitter();
  @Input() selectedProducts: any[] = [];
  @Output() reload = new EventEmitter<any>();

  isLoading = false;

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  constructor(
    private api: LeadService,
    private localStorage: LocalStorageService
  ) { }

  handleMove() {

    const payload = {
      organization_id: this.localStorage.getOrganizationId(),
      lead_id: this.selectedProducts?.map(product => product?.lead_id),
      reg_id: this.selectedProducts?.map(product => product?.registration?.reg_id),
      current_stage: 'application',
      reg_data: {},
      old_lead_data: {},
      user_id: this.localStorage.getUserId(),
      application_date : new Date().toISOString(),
      status: "In Progress"
    }

    this.isLoading = true;

    this.api.updateBulkLead(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.closeDialog.emit();
      },
      error: (error) => {
        this.isLoading = false;
      }
    }
    );

  }
}
